module.exports = __webpack_public_path__ + "static/media/kababa.2822fbfc.jpg";